import { useCallback, useMemo } from 'react';

import { useLocalStorage } from '@uidotdev/usehooks';

import type { NewsItem } from './use-news-items';

export const useUnreadCount = (featureReleases: NewsItem[]) => {
  const [lastViewed, setLastViewed] = useLocalStorage<Date | null>(
    'WHATS_NEW_LAST_VIEWED',
    null,
  );

  const unreadCount = featureReleases.filter(
    ({ date }) =>
      lastViewed === null || (lastViewed && date && date.diff(lastViewed) > 0),
  ).length;

  const markAllRead = useCallback(() => {
    setLastViewed(new Date());
  }, [setLastViewed]);

  return useMemo(
    () => ({ unreadCount, markAllRead }),
    [markAllRead, unreadCount],
  );
};
